import React from 'react';

import { Group, Text } from '@mantine/core';

import styles from './cells.module.scss';

interface ClinicCellProps {
  clinicName: string;
}

export const ClinicCell: React.FC<ClinicCellProps> = ({ clinicName }) => (
  <Group gap={4} align="center">
    <Text className={styles.cellText}>{clinicName || 'No Clinic'}</Text>
  </Group>
);
